// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --red: #d35400;
  --red-dark: #ba4a00;
  --green: #1a5c38;
  --green-mid: #27ae60;
  --gray-900: #1f2937;
  --gray-700: #374151;
  --gray-600: #4b5563;
  --gray-500: #6b7280;
  --gray-400: #9ca3af;
  --gray-200: #e5e7eb;
  --gray-100: #f3f4f6;
  --gray-50: #f9fafb;
  --border: #e5e7eb;
  --radius: 6px;
  --radius-lg: 12px;
  --shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
}

.AdminQuestions_page__cLKaP {
  padding: 1.5rem;
  max-width: 1600px;
  margin: 0 auto;
}

.AdminQuestions_pageHeader__3xrJO {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 1.5rem;
}

.AdminQuestions_pageTitle__xgFUi { font-size: 1.5rem; color: var(--gray-900); font-weight: 600; }
.AdminQuestions_pageSub__YfaKW { font-size: 0.85rem; color: var(--gray-500); margin-top: 0.25rem; }

.AdminQuestions_actionBtn__X-yAn {
  padding: 0.6rem 1.2rem;
  background: var(--red);
  color: white;
  border: none;
  border-radius: var(--radius);
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}
.AdminQuestions_actionBtn__X-yAn:hover { background: var(--red-dark); }

.AdminQuestions_headerActions__pog13 {
  display: flex;
  gap: 0.75rem;
  align-items: center;
}

/* Tabs */
.AdminQuestions_tabs__KaEM1 {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.5rem;
  border-bottom: 1px solid var(--border);
  overflow-x: auto;
}

.AdminQuestions_tab__b73p7 {
  padding: 0.65rem 1rem;
  background: transparent;
  border: none;
  border-bottom: 2px solid transparent;
  color: var(--gray-600);
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}
.AdminQuestions_tab__b73p7:hover { color: var(--gray-900); }
.AdminQuestions_tabActive__LGtc- {
  color: var(--red);
  border-bottom-color: var(--red);
}

/* Filter Section */
.AdminQuestions_filterSection__\\+Q0jU {
  display: flex;
  align-items: center;
  gap: 1rem;
  padding: 0.75rem 1rem;
  background: var(--gray-50);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  margin-bottom: 1.5rem;
}

.AdminQuestions_filterLabel__Umg5E {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--gray-700);
  white-space: nowrap;
}

.AdminQuestions_roleFilter__nLFEy {
  padding: 0.5rem 0.75rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-size: 0.85rem;
  background: white;
  color: var(--gray-900);
  cursor: pointer;
  transition: border-color 0.2s;
}

.AdminQuestions_roleFilter__nLFEy:hover {
  border-color: var(--red);
}

.AdminQuestions_roleFilter__nLFEy:focus {
  outline: none;
  border-color: var(--red);
  box-shadow: 0 0 0 2px rgba(211, 84, 0, 0.1);
}

/* Questions List */
.AdminQuestions_questionsList__ZrB3H { }

.AdminQuestions_sectionHeader__MaQPe {
  padding: 0.85rem 1rem;
  background: var(--gray-50);
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  font-size: 0.9rem;
  color: var(--gray-700);
  font-weight: 500;
  margin-bottom: 1rem;
}

.AdminQuestions_empty__1ygx- {
  text-align: center;
  padding: 2rem;
  color: var(--gray-500);
  font-size: 0.9rem;
}

.AdminQuestions_loading__2t3Uy {
  text-align: center;
  padding: 2rem;
  color: var(--gray-500);
}

/* Question Item */
.AdminQuestions_questionItem__axjvz {
  background: white;
  border: 1px solid var(--border);
  border-radius: var(--radius-lg);
  padding: 1rem;
  margin-bottom: 0.75rem;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 1rem;
}

.AdminQuestions_questionContent__ynOFi { flex: 1 1; }

.AdminQuestions_qNum__YY1eZ {
  display: inline-block;
  font-weight: 600;
  color: var(--red);
  margin-right: 0.5rem;
}

.AdminQuestions_qText__nYe9D {
  font-size: 0.9rem;
  color: var(--gray-900);
  line-height: 1.5;
  margin-bottom: 0.5rem;
}

.AdminQuestions_qMeta__IvoUv {
  display: flex;
  gap: 0.75rem;
  align-items: center;
  flex-wrap: wrap;
}

.AdminQuestions_badge__7ejIr {
  display: inline-block;
  padding: 2px 8px;
  background: var(--gray-100);
  color: var(--gray-700);
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: capitalize;
}

.AdminQuestions_roleBadge__8YVSZ {
  display: inline-block;
  padding: 2px 8px;
  background: #e0f2fe;
  color: #0369a1;
  border-radius: 4px;
  font-size: 0.7rem;
  font-weight: 600;
  text-transform: capitalize;
}

.AdminQuestions_answer__cP8Zn {
  font-size: 0.75rem;
  color: var(--green);
  font-weight: 500;
}

.AdminQuestions_score__oXszd {
  font-size: 0.75rem;
  color: var(--gray-500);
}

.AdminQuestions_questionActions__Tqgxl {
  display: flex;
  gap: 0.5rem;
}

.AdminQuestions_editBtn__6lJ9s, .AdminQuestions_deleteBtn__HLHhN {
  padding: 0.4rem 0.8rem;
  border: none;
  border-radius: var(--radius);
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
}

.AdminQuestions_editBtn__6lJ9s {
  background: var(--gray-100);
  color: var(--gray-700);
}
.AdminQuestions_editBtn__6lJ9s:hover { background: var(--gray-200); }

.AdminQuestions_deleteBtn__HLHhN {
  background: #fee;
  color: #c00;
}
.AdminQuestions_deleteBtn__HLHhN:hover { background: #fdd; }

/* Edit Form */
.AdminQuestions_editForm__NXiF6 {
  width: 100%;
}

.AdminQuestions_textInput__nI0Dc, .AdminQuestions_smallInput__EaIkz {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-size: 0.85rem;
  margin-bottom: 0.5rem;
  font-family: inherit;
}

.AdminQuestions_smallInput__EaIkz { width: auto; }

.AdminQuestions_editRow__Escd5 {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.AdminQuestions_editRow__Escd5 .AdminQuestions_smallInput__EaIkz {
  flex: 1 1;
  width: 100%;
}

.AdminQuestions_editActions__aTNzd {
  display: flex;
  gap: 0.5rem;
}

.AdminQuestions_saveBtn__W4V2W {
  padding: 0.4rem 0.8rem;
  background: var(--green);
  color: white;
  border: none;
  border-radius: var(--radius);
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
}
.AdminQuestions_saveBtn__W4V2W:hover { background: var(--green-mid); }

.AdminQuestions_cancelBtn__ftNRB {
  padding: 0.4rem 0.8rem;
  background: var(--gray-200);
  color: var(--gray-700);
  border: none;
  border-radius: var(--radius);
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
}
.AdminQuestions_cancelBtn__ftNRB:hover { background: var(--gray-300); }

/* Modal */
.AdminQuestions_modalOverlay__lz17i {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 100;
}

.AdminQuestions_modal__6yG6Y {
  background: white;
  border-radius: var(--radius-lg);
  padding: 2rem;
  max-width: 500px;
  width: 90%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);
}

.AdminQuestions_modalTitle__ZS6JM {
  font-size: 1.1rem;
  color: var(--gray-900);
  margin-bottom: 1.5rem;
  font-weight: 600;
}

/* Form */
.AdminQuestions_form__IQ6s9 {
  display: flex;
  flex-direction: column;
  gap: 1rem;
}

.AdminQuestions_formGroup__EdRI1 {
  display: flex;
  flex-direction: column;
}

.AdminQuestions_formGroup__EdRI1 label {
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--gray-700);
  margin-bottom: 0.4rem;
}

.AdminQuestions_input__E2AAG, .AdminQuestions_textarea__wjwYo {
  padding: 0.65rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-size: 0.85rem;
  font-family: inherit;
}

.AdminQuestions_input__E2AAG:focus, .AdminQuestions_textarea__wjwYo:focus {
  outline: none;
  border-color: var(--red);
  box-shadow: 0 0 0 2px rgba(211, 84, 0, 0.1);
}

.AdminQuestions_textarea__wjwYo {
  resize: vertical;
  min-height: 100px;
}

.AdminQuestions_formActions__-B3pZ {
  display: flex;
  gap: 0.75rem;
  margin-top: 1rem;
}

.AdminQuestions_submitBtn__7nuhB {
  flex: 1 1;
  padding: 0.65rem 1rem;
  background: var(--red);
  color: white;
  border: none;
  border-radius: var(--radius);
  font-size: 0.85rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}
.AdminQuestions_submitBtn__7nuhB:hover { background: var(--red-dark); }

.AdminQuestions_formActions__-B3pZ .AdminQuestions_cancelBtn__ftNRB {
  flex: 1 1;
}

/* Options Section */
.AdminQuestions_optionsSection__h\\+bzZ {
  margin: 1rem 0;
  padding: 1rem;
  background: var(--gray-50);
  border: 1px solid var(--border);
  border-radius: var(--radius);
}

.AdminQuestions_optionsLabel__ci4ar {
  display: block;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--gray-700);
  margin-bottom: 0.75rem;
}

.AdminQuestions_optionRow__jxgHN {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 0.5rem;
}

.AdminQuestions_optionInput__Iavn5 {
  flex: 1 1;
  padding: 0.5rem;
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-size: 0.85rem;
  font-family: inherit;
}

.AdminQuestions_optionInput__Iavn5:focus {
  outline: none;
  border-color: var(--red);
  box-shadow: 0 0 0 2px rgba(211, 84, 0, 0.1);
}

.AdminQuestions_removeBtn__7ycjQ {
  padding: 0.4rem 0.8rem;
  background: #fdd;
  color: #c33;
  border: 1px solid #dbb;
  border-radius: var(--radius);
  font-size: 0.75rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}
.AdminQuestions_removeBtn__7ycjQ:hover { background: #fcc; }

.AdminQuestions_addOptionBtn__P-xKE {
  padding: 0.5rem 1rem;
  background: var(--gray-200);
  color: var(--gray-700);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  font-size: 0.8rem;
  font-weight: 500;
  cursor: pointer;
  transition: background 0.15s;
}
.AdminQuestions_addOptionBtn__P-xKE:hover { background: var(--gray-300); }

@media (max-width: 768px) {
  .AdminQuestions_pageHeader__3xrJO {
    flex-direction: column;
    align-items: flex-start;
    gap: 1rem;
  }

  .AdminQuestions_tabs__KaEM1 {
    overflow-x: auto;
  }

  .AdminQuestions_questionItem__axjvz {
    flex-direction: column;
  }

  .AdminQuestions_questionActions__Tqgxl {
    width: 100%;
  }

  .AdminQuestions_modal__6yG6Y {
    width: 95%;
    padding: 1.5rem;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/AdminQuestions.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,mBAAmB;EACnB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,mBAAmB;EACnB,kBAAkB;EAClB,iBAAiB;EACjB,aAAa;EACb,iBAAiB;EACjB,sCAAsC;AACxC;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,qBAAqB;AACvB;;AAEA,mCAAa,iBAAiB,EAAE,sBAAsB,EAAE,gBAAgB,EAAE;AAC1E,iCAAW,kBAAkB,EAAE,sBAAsB,EAAE,mBAAmB,EAAE;;AAE5E;EACE,sBAAsB;EACtB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,yCAAmB,2BAA2B,EAAE;;AAEhD;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;AACrB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;EACrB,sCAAsC;EACtC,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,uBAAuB;EACvB,YAAY;EACZ,oCAAoC;EACpC,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;AACrB;AACA,mCAAa,sBAAsB,EAAE;AACrC;EACE,iBAAiB;EACjB,+BAA+B;AACjC;;AAEA,mBAAmB;AACnB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,qBAAqB;EACrB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,iBAAiB;EACjB,sBAAsB;EACtB,eAAe;EACf,6BAA6B;AAC/B;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA,mBAAmB;AACnB,uCAAiB;;AAEjB;EACE,qBAAqB;EACrB,0BAA0B;EAC1B,+BAA+B;EAC/B,+BAA+B;EAC/B,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;AACxB;;AAEA,kBAAkB;AAClB;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,+BAA+B;EAC/B,aAAa;EACb,sBAAsB;EACtB,aAAa;EACb,8BAA8B;EAC9B,uBAAuB;EACvB,SAAS;AACX;;AAEA,yCAAmB,SAAO,EAAE;;AAE5B;EACE,qBAAqB;EACrB,gBAAgB;EAChB,iBAAiB;EACjB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,2BAA2B;EAC3B,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,iBAAiB;EACjB,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,2BAA2B;EAC3B,sBAAsB;AACxB;AACA,uCAAiB,2BAA2B,EAAE;;AAE9C;EACE,gBAAgB;EAChB,WAAW;AACb;AACA,yCAAmB,gBAAgB,EAAE;;AAErC,cAAc;AACd;EACE,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA,oCAAc,WAAW,EAAE;;AAE3B;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,WAAW;AACb;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA,uCAAiB,4BAA4B,EAAE;;AAE/C;EACE,sBAAsB;EACtB,2BAA2B;EAC3B,sBAAsB;EACtB,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;AACjB;AACA,yCAAmB,2BAA2B,EAAE;;AAEhD,UAAU;AACV;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;AACd;;AAEA;EACE,iBAAiB;EACjB,+BAA+B;EAC/B,aAAa;EACb,gBAAgB;EAChB,UAAU;EACV,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA,SAAS;AACT;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,qBAAqB;EACrB,sBAAsB;EACtB,YAAY;EACZ,YAAY;EACZ,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,yCAAmB,2BAA2B,EAAE;;AAEhD;EACE,SAAO;AACT;;AAEA,oBAAoB;AACpB;EACE,cAAc;EACd,aAAa;EACb,0BAA0B;EAC1B,+BAA+B;EAC/B,4BAA4B;AAC9B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,+BAA+B;EAC/B,4BAA4B;EAC5B,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,wBAAwB;EACxB,2CAA2C;AAC7C;;AAEA;EACE,sBAAsB;EACtB,gBAAgB;EAChB,WAAW;EACX,sBAAsB;EACtB,4BAA4B;EAC5B,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,yCAAmB,gBAAgB,EAAE;;AAErC;EACE,oBAAoB;EACpB,2BAA2B;EAC3B,sBAAsB;EACtB,+BAA+B;EAC/B,4BAA4B;EAC5B,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,4BAA4B;AAC9B;AACA,4CAAsB,2BAA2B,EAAE;;AAEnD;EACE;IACE,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;EACX;;EAEA;IACE,gBAAgB;EAClB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;EACb;;EAEA;IACE,UAAU;IACV,eAAe;EACjB;AACF","sourcesContent":[":root {\n  --red: #d35400;\n  --red-dark: #ba4a00;\n  --green: #1a5c38;\n  --green-mid: #27ae60;\n  --gray-900: #1f2937;\n  --gray-700: #374151;\n  --gray-600: #4b5563;\n  --gray-500: #6b7280;\n  --gray-400: #9ca3af;\n  --gray-200: #e5e7eb;\n  --gray-100: #f3f4f6;\n  --gray-50: #f9fafb;\n  --border: #e5e7eb;\n  --radius: 6px;\n  --radius-lg: 12px;\n  --shadow: 0 1px 3px rgba(0, 0, 0, 0.1);\n}\n\n.page {\n  padding: 1.5rem;\n  max-width: 1600px;\n  margin: 0 auto;\n}\n\n.pageHeader {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n}\n\n.pageTitle { font-size: 1.5rem; color: var(--gray-900); font-weight: 600; }\n.pageSub { font-size: 0.85rem; color: var(--gray-500); margin-top: 0.25rem; }\n\n.actionBtn {\n  padding: 0.6rem 1.2rem;\n  background: var(--red);\n  color: white;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.actionBtn:hover { background: var(--red-dark); }\n\n.headerActions {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n}\n\n/* Tabs */\n.tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.5rem;\n  border-bottom: 1px solid var(--border);\n  overflow-x: auto;\n}\n\n.tab {\n  padding: 0.65rem 1rem;\n  background: transparent;\n  border: none;\n  border-bottom: 2px solid transparent;\n  color: var(--gray-600);\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.2s;\n  white-space: nowrap;\n}\n.tab:hover { color: var(--gray-900); }\n.tabActive {\n  color: var(--red);\n  border-bottom-color: var(--red);\n}\n\n/* Filter Section */\n.filterSection {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n  padding: 0.75rem 1rem;\n  background: var(--gray-50);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  margin-bottom: 1.5rem;\n}\n\n.filterLabel {\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--gray-700);\n  white-space: nowrap;\n}\n\n.roleFilter {\n  padding: 0.5rem 0.75rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n  background: white;\n  color: var(--gray-900);\n  cursor: pointer;\n  transition: border-color 0.2s;\n}\n\n.roleFilter:hover {\n  border-color: var(--red);\n}\n\n.roleFilter:focus {\n  outline: none;\n  border-color: var(--red);\n  box-shadow: 0 0 0 2px rgba(211, 84, 0, 0.1);\n}\n\n/* Questions List */\n.questionsList { }\n\n.sectionHeader {\n  padding: 0.85rem 1rem;\n  background: var(--gray-50);\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  font-size: 0.9rem;\n  color: var(--gray-700);\n  font-weight: 500;\n  margin-bottom: 1rem;\n}\n\n.empty {\n  text-align: center;\n  padding: 2rem;\n  color: var(--gray-500);\n  font-size: 0.9rem;\n}\n\n.loading {\n  text-align: center;\n  padding: 2rem;\n  color: var(--gray-500);\n}\n\n/* Question Item */\n.questionItem {\n  background: white;\n  border: 1px solid var(--border);\n  border-radius: var(--radius-lg);\n  padding: 1rem;\n  margin-bottom: 0.75rem;\n  display: flex;\n  justify-content: space-between;\n  align-items: flex-start;\n  gap: 1rem;\n}\n\n.questionContent { flex: 1; }\n\n.qNum {\n  display: inline-block;\n  font-weight: 600;\n  color: var(--red);\n  margin-right: 0.5rem;\n}\n\n.qText {\n  font-size: 0.9rem;\n  color: var(--gray-900);\n  line-height: 1.5;\n  margin-bottom: 0.5rem;\n}\n\n.qMeta {\n  display: flex;\n  gap: 0.75rem;\n  align-items: center;\n  flex-wrap: wrap;\n}\n\n.badge {\n  display: inline-block;\n  padding: 2px 8px;\n  background: var(--gray-100);\n  color: var(--gray-700);\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.roleBadge {\n  display: inline-block;\n  padding: 2px 8px;\n  background: #e0f2fe;\n  color: #0369a1;\n  border-radius: 4px;\n  font-size: 0.7rem;\n  font-weight: 600;\n  text-transform: capitalize;\n}\n\n.answer {\n  font-size: 0.75rem;\n  color: var(--green);\n  font-weight: 500;\n}\n\n.score {\n  font-size: 0.75rem;\n  color: var(--gray-500);\n}\n\n.questionActions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.editBtn, .deleteBtn {\n  padding: 0.4rem 0.8rem;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.15s;\n}\n\n.editBtn {\n  background: var(--gray-100);\n  color: var(--gray-700);\n}\n.editBtn:hover { background: var(--gray-200); }\n\n.deleteBtn {\n  background: #fee;\n  color: #c00;\n}\n.deleteBtn:hover { background: #fdd; }\n\n/* Edit Form */\n.editForm {\n  width: 100%;\n}\n\n.textInput, .smallInput {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n  margin-bottom: 0.5rem;\n  font-family: inherit;\n}\n\n.smallInput { width: auto; }\n\n.editRow {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.editRow .smallInput {\n  flex: 1;\n  width: 100%;\n}\n\n.editActions {\n  display: flex;\n  gap: 0.5rem;\n}\n\n.saveBtn {\n  padding: 0.4rem 0.8rem;\n  background: var(--green);\n  color: white;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n}\n.saveBtn:hover { background: var(--green-mid); }\n\n.cancelBtn {\n  padding: 0.4rem 0.8rem;\n  background: var(--gray-200);\n  color: var(--gray-700);\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n}\n.cancelBtn:hover { background: var(--gray-300); }\n\n/* Modal */\n.modalOverlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 100;\n}\n\n.modal {\n  background: white;\n  border-radius: var(--radius-lg);\n  padding: 2rem;\n  max-width: 500px;\n  width: 90%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.1);\n}\n\n.modalTitle {\n  font-size: 1.1rem;\n  color: var(--gray-900);\n  margin-bottom: 1.5rem;\n  font-weight: 600;\n}\n\n/* Form */\n.form {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n}\n\n.formGroup {\n  display: flex;\n  flex-direction: column;\n}\n\n.formGroup label {\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--gray-700);\n  margin-bottom: 0.4rem;\n}\n\n.input, .textarea {\n  padding: 0.65rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n  font-family: inherit;\n}\n\n.input:focus, .textarea:focus {\n  outline: none;\n  border-color: var(--red);\n  box-shadow: 0 0 0 2px rgba(211, 84, 0, 0.1);\n}\n\n.textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.formActions {\n  display: flex;\n  gap: 0.75rem;\n  margin-top: 1rem;\n}\n\n.submitBtn {\n  flex: 1;\n  padding: 0.65rem 1rem;\n  background: var(--red);\n  color: white;\n  border: none;\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.submitBtn:hover { background: var(--red-dark); }\n\n.formActions .cancelBtn {\n  flex: 1;\n}\n\n/* Options Section */\n.optionsSection {\n  margin: 1rem 0;\n  padding: 1rem;\n  background: var(--gray-50);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n}\n\n.optionsLabel {\n  display: block;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--gray-700);\n  margin-bottom: 0.75rem;\n}\n\n.optionRow {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.optionInput {\n  flex: 1;\n  padding: 0.5rem;\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 0.85rem;\n  font-family: inherit;\n}\n\n.optionInput:focus {\n  outline: none;\n  border-color: var(--red);\n  box-shadow: 0 0 0 2px rgba(211, 84, 0, 0.1);\n}\n\n.removeBtn {\n  padding: 0.4rem 0.8rem;\n  background: #fdd;\n  color: #c33;\n  border: 1px solid #dbb;\n  border-radius: var(--radius);\n  font-size: 0.75rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.removeBtn:hover { background: #fcc; }\n\n.addOptionBtn {\n  padding: 0.5rem 1rem;\n  background: var(--gray-200);\n  color: var(--gray-700);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  font-size: 0.8rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: background 0.15s;\n}\n.addOptionBtn:hover { background: var(--gray-300); }\n\n@media (max-width: 768px) {\n  .pageHeader {\n    flex-direction: column;\n    align-items: flex-start;\n    gap: 1rem;\n  }\n\n  .tabs {\n    overflow-x: auto;\n  }\n\n  .questionItem {\n    flex-direction: column;\n  }\n\n  .questionActions {\n    width: 100%;\n  }\n\n  .modal {\n    width: 95%;\n    padding: 1.5rem;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"page": `AdminQuestions_page__cLKaP`,
	"pageHeader": `AdminQuestions_pageHeader__3xrJO`,
	"pageTitle": `AdminQuestions_pageTitle__xgFUi`,
	"pageSub": `AdminQuestions_pageSub__YfaKW`,
	"actionBtn": `AdminQuestions_actionBtn__X-yAn`,
	"headerActions": `AdminQuestions_headerActions__pog13`,
	"tabs": `AdminQuestions_tabs__KaEM1`,
	"tab": `AdminQuestions_tab__b73p7`,
	"tabActive": `AdminQuestions_tabActive__LGtc-`,
	"filterSection": `AdminQuestions_filterSection__+Q0jU`,
	"filterLabel": `AdminQuestions_filterLabel__Umg5E`,
	"roleFilter": `AdminQuestions_roleFilter__nLFEy`,
	"questionsList": `AdminQuestions_questionsList__ZrB3H`,
	"sectionHeader": `AdminQuestions_sectionHeader__MaQPe`,
	"empty": `AdminQuestions_empty__1ygx-`,
	"loading": `AdminQuestions_loading__2t3Uy`,
	"questionItem": `AdminQuestions_questionItem__axjvz`,
	"questionContent": `AdminQuestions_questionContent__ynOFi`,
	"qNum": `AdminQuestions_qNum__YY1eZ`,
	"qText": `AdminQuestions_qText__nYe9D`,
	"qMeta": `AdminQuestions_qMeta__IvoUv`,
	"badge": `AdminQuestions_badge__7ejIr`,
	"roleBadge": `AdminQuestions_roleBadge__8YVSZ`,
	"answer": `AdminQuestions_answer__cP8Zn`,
	"score": `AdminQuestions_score__oXszd`,
	"questionActions": `AdminQuestions_questionActions__Tqgxl`,
	"editBtn": `AdminQuestions_editBtn__6lJ9s`,
	"deleteBtn": `AdminQuestions_deleteBtn__HLHhN`,
	"editForm": `AdminQuestions_editForm__NXiF6`,
	"textInput": `AdminQuestions_textInput__nI0Dc`,
	"smallInput": `AdminQuestions_smallInput__EaIkz`,
	"editRow": `AdminQuestions_editRow__Escd5`,
	"editActions": `AdminQuestions_editActions__aTNzd`,
	"saveBtn": `AdminQuestions_saveBtn__W4V2W`,
	"cancelBtn": `AdminQuestions_cancelBtn__ftNRB`,
	"modalOverlay": `AdminQuestions_modalOverlay__lz17i`,
	"modal": `AdminQuestions_modal__6yG6Y`,
	"modalTitle": `AdminQuestions_modalTitle__ZS6JM`,
	"form": `AdminQuestions_form__IQ6s9`,
	"formGroup": `AdminQuestions_formGroup__EdRI1`,
	"input": `AdminQuestions_input__E2AAG`,
	"textarea": `AdminQuestions_textarea__wjwYo`,
	"formActions": `AdminQuestions_formActions__-B3pZ`,
	"submitBtn": `AdminQuestions_submitBtn__7nuhB`,
	"optionsSection": `AdminQuestions_optionsSection__h+bzZ`,
	"optionsLabel": `AdminQuestions_optionsLabel__ci4ar`,
	"optionRow": `AdminQuestions_optionRow__jxgHN`,
	"optionInput": `AdminQuestions_optionInput__Iavn5`,
	"removeBtn": `AdminQuestions_removeBtn__7ycjQ`,
	"addOptionBtn": `AdminQuestions_addOptionBtn__P-xKE`
};
export default ___CSS_LOADER_EXPORT___;
